export default "__VITE_ASSET__D61AVf8R__"